import { FormikField } from "@components/forms/FormikField/FormikField";
import { Picker } from "@design-system/Picker/Picker.lib";
import { getMultiSelectTriggerValue } from "@components/onboarding/lib";

interface MultiSelectRowProps<T extends string> {
    name: string;
    label: string;
    items: Array<{ value: T; label: string }>;
    value: T[];
    onChange(value: T[]): void;
    onBlur(): void;
}

export const MultiSelectRow = <T extends string>({
    name,
    label,
    items,
    value,
    onChange,
    onBlur,
}: Readonly<MultiSelectRowProps<T>>) => {
    const labelFor = (itemValue: T) =>
        items.find((item) => item.value === itemValue)?.label ?? itemValue;

    return (
        <FormikField<T[]> name={name} label={label} control="button">
            {({ invalid }) => (
                <Picker.Select
                    multiple
                    items={items}
                    value={value}
                    onValueChange={onChange}
                    onOpenChange={(open) => {
                        if (!open) {
                            onBlur();
                        }
                    }}
                    renderValue={(selectedValues) =>
                        getMultiSelectTriggerValue(
                            [...selectedValues],
                            items.length,
                            labelFor,
                        )
                    }
                    placeholder="Select"
                    aria-invalid={invalid}
                    trigger={
                        <Picker.Button variant="primary" size="xl" block />
                    }
                />
            )}
        </FormikField>
    );
};
